import WhatsOnChain from './WhatsOnChain.js';
export function defaultChainTracker() {
    return new WhatsOnChain();
}
//# sourceMappingURL=DefaultChainTracker.js.map